import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalVariableService } from '../../../../services/configuration/global-variable.service';
import { GenericModalService } from '../../../../services/generic-modal.service';
import {CustomValidator} from '../../../../services/custom-validator';
import {MetadataService} from '../../../../services/configuration/metadata.service';
import {EnumTranslateService} from '../../../../services/enumTranslate-service';
import {DateTimeService} from '../../../../services/date-time.service';

@Component({
  selector: 'app-metadata-structure-modal',
  templateUrl: './user-metadata-admin-modal.component.html',
  styleUrls: ['./user-metadata-admin-modal.component.css', '../../../../styles/modals.css']
})
export class UserMetadataAdminModalComponent implements OnInit, AfterViewInit {

  get formData() { return this.metadataForm.controls; }

  constructor(
    public bsModalRef: BsModalRef,
    private formBuilder: FormBuilder,
    private metadataService: MetadataService,
    private dateTimeService: DateTimeService
  ) { }

  @Input() modalTitle: string;
  itemSaved: Subject<boolean> = new Subject();
  metadataForm: FormGroup;
  objInitialState: any;
  metadataValue;
  userId;
  submitted = false;
  submitClick = false;
  errorMessage = '';

  ngOnInit() {
    this.createForm();
  }

  ngAfterViewInit() {
    this.metadataValue = this.objInitialState.metadata;
    this.userId = this.objInitialState.userId;
    this.patchValues();
  }

  createForm() {
    this.metadataForm = this.formBuilder.group({
      structure: this.formBuilder.group({
        metadataStructureId: [0],
        name: '',
        description: '',
        type: 0,
        editingBy: 0,
        domain: null,
        category: 0
    }),
      typeDescription: null,
      value: [null],
      domain: [null]
    });
  }

  get type(): any {
    return this.metadataForm.get('structure.type').value;
  }

  patchValues() {
    this.metadataForm.get('structure.name').disable();
    this.metadataForm.get('typeDescription').disable();

    this.metadataForm.patchValue({
      structure: this.metadataValue.structure,
      typeDescription: this.metadataValue.typeDescription,
      value: this.metadataValue.value,
      domain: this.metadataValue.domain,
    });
    switch (this.metadataValue.structure.type) {
      case 1:/*integer*/
        this.metadataForm.get('value').setValidators([CustomValidator.numericPositiveAndNegativeNotRequired,Validators.max(2147482)]);
        this.createDomainArray();
        break;
      case 3:/*text*/
        this.metadataForm.get('value').setValidators([Validators.maxLength(300)]);
        this.createDomainArray();
        break;
      case 2:/*date*/
        if (this.metadataValue.domain) {
          let newDomain = [];
          this.metadataValue.domain.forEach(d => {
            newDomain.push({value: d, brValue: this.dateTimeService.formatBrDateTime(d)});
          });
          this.metadataForm.get('domain').setValue(newDomain);
          this.metadataForm.get('value').setValue(this.dateTimeService.toUTC(this.metadataValue.value));
        } else if (this.metadataValue.value) {
          this.metadataForm.get('value').setValue(this.dateTimeService.formatDateTimePickerFormat(this.metadataValue.value));
        }
        break;
      case 4:/*floating*/
        if (this.metadataValue.domain){
          let newDomain = [];
          this.metadataValue.domain.forEach(d => {
            newDomain.push({value: d, brValue: d.toString().replace('.',',')})
          });
          this.metadataForm.get('domain').setValue(newDomain);
        } else if (this.metadataValue.value){
          this.metadataForm.get('value').setValue(this.metadataValue.value.toString().replace('.',','));
        }
        this.metadataForm.get('value').setValidators(CustomValidator.decimalNotRequired);

        break;
    }
    this.metadataForm.updateValueAndValidity();
  }

  createDomainArray(){
    if (!this.metadataValue.domain) return;
    let newDomain = [];
    this.metadataValue.domain.forEach(d => {
      newDomain.push({value: d, brValue: d});
    });
    this.metadataForm.get('domain').setValue(newDomain);
  }

  cleanDomain() {
    this.formData.domain.setValue([]);
  }

  getNumber(sNumber) {
    return Number(sNumber);
  }

  blockUserInput() {
    return false;
  }

  onSave() {
    this.errorMessage = '';
    const obj = this.metadataForm.getRawValue();

    if (this.metadataValue.structure.type == 2 && this.metadataValue.domain){
      obj.value = this.dateTimeService.toISOStringDateTime(obj.value.toString())
    } else if (this.metadataValue.structure.type == 4 && this.metadataValue.domain){
      obj.value = obj.value.toString().replace('.',',');
    }

    this.metadataService.saveUserMetadataValueByAdmin(this.userId, obj)
      .subscribe( () => {
          this.submitted = true;
          this.itemSaved.next(true);
          setTimeout(() => { this.submitted = false; this.bsModalRef.hide(); }, 2000);
        },
        error => {
          let err = error;
          if (error.indexOf('401') !== -1) {
            err = 'Erro: Sessão expirada.';
          }
          this.errorMessage = err;
          this.submitClick = false;
        });
  }

  onClose() {
    this.itemSaved.next(false);
    this.bsModalRef.hide();
  }


}
